import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-request-solar',
  templateUrl: './request-solar.component.html',
  styleUrls: ['./request-solar.component.scss']
})
export class RequestSolarComponent implements OnInit {
  @ViewChild('queryDataTable', { static: true })
  public queryDataTable: Table;
  
  public userId: any;
  public query: any;
  public password: any;

  public tableData: any = [];
  public tableColumns: any = [];

  public isSubmitted: boolean = false;

  constructor(
    private cryptoJsService: CryptoJsService, 
    private activityRecordService: ActivityRecordService,
    private messageService: MessageService,
    private loader: AppLoaderService,
    private apiService: DashboardService,
  ) { }


  ngOnInit(): void {
    const token: any = JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')));    
    // console.log('token1', token);
    // this.vendorRegId = JSON.stringify(token?.officeCode);
    // console.log('officeCode', this.vendorRegId);
    let payload = atob(token?.authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

  }

  onSubmit() {
    if(this.query == null || this.query == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please write a proper query.',
      });
      return;
    }
    if(this.password == null || this.password == ""){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Please Enter Password.',
      });
      return;
    }
    let reqBody = {
      encContent: this.cryptoJsService.Encrypt(this.query),
      userId: this.userId ? this.cryptoJsService.Encrypt(this.userId) : '',
      passCode: this.cryptoJsService.Encrypt(this.password)
    }
    this.postQuery(reqBody);
  }


  postQuery(reqBody){
    this.isSubmitted  = true;
    this.loader.start();
    this.apiService
      .requestSolar(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          // this.query = null;
          this.password = null;

          if(Array.isArray(data) ?  data.length == 0 : false){
            this.tableColumns = [];
            this.tableData = [];
          }
          else{
            this.tableColumns = Object.keys(data[0])
            this.tableData = data;
          }
          
        },
        error: (err) => {
          this.loader.close();
          this.isSubmitted = false;
          this.tableColumns = [];
          this.tableData = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        }
      });
  }


}
